<div class="root">
    <section class="header">
        <nlr-header [menuItem]="title"></nlr-header>
    </section>

    <section class="hamburger">
        <nlr-hamburger
            [planInformationForm]="getPlanInformationForm()"
            [analysisForm]="getAnalysisForm()"
            [certificationForm]="getCertificationForm()"
            [interestsForm]="getInterestsForm()"
            [lodgePlanForm]="getLodgePlanForm()"
            [digitalPlanValidationState]="getDigitalPlanValidationState()"></nlr-hamburger>
    </section>

    <section
        id="inner"
        class="content">
        <!-- For customising the split gutter style see: https://github.com/angular-split/angular-split/blob/main/src/app/examples/custom-gutter-style/custom-gutter-style.component.scss -->
        <as-split
            unit="percent"
            gutterSize="11"
            gutterAriaLabel="show me the money">
            <div
                *asSplitGutter
                class="custom-collapse-gutter">
                <div class="custom-collapse-gutter-header"> </div>
                @if (sizeIndex > 0) {
                    <div
                        asSplitGutterExcludeFromDrag
                        class="custom-expand-button-left"
                        [title]="direction"
                        (click)="collapsePanel('left')">
                        <i class="nlrp-icon nlrp-icon-left-chevron"></i>
                    </div>
                }
                <div class="nlrp-icon nlrp-icon-vertical-move"></div>
                @if (sizeIndex < 2) {
                    <div
                        asSplitGutterExcludeFromDrag
                        class="custom-expand-button-right"
                        (click)="collapsePanel('right')">
                        <i class="nlrp-icon nlrp-icon-right-chevron"></i>
                    </div>
                }
                <div class="custom-collapse-gutter-ghost"></div>
            </div>
            <as-split-area
                [size]="leftPanelSize()"
                [minSize]="getLeftPanelMinSize()">
                <section class="left">
                    <nlr-left></nlr-left>
                </section>
            </as-split-area>
            <as-split-area
                id="right-split-area"
                [size]="rightPanelSize()">
                <section>
                    <nlr-right></nlr-right>
                </section>
            </as-split-area>
        </as-split>
    </section>

    <section class="footer">
        <nlr-footer></nlr-footer>
    </section>
</div>
